import React, { useContext, useEffect, useState } from "react";
import "./PolicyStageThree.css";
import "./PremiumPlanModal.css";
import cancelIcon from "../../../../images/cancel-icon.svg";
import { UserContext } from "../../../../components/contexts/UserContext";
import { IAllCargosInputStates } from "../../../../Types";
import isEmpty from "../../../../validation/isEmpty";
import { InfoCircleOutlined } from "@ant-design/icons";
import { allClauseTypes } from "../../../../utils/allClauseTypes";
import { getInsurancePremium } from "../../../../utils/generatePremium";
import { ISinglePolicyPlan } from "./PolicyStageThree";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  allCargosInputStates: IAllCargosInputStates[];
  currentActiveCargoIndex: number;
  setIsSumInsuredBreakdownModalOpened: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setPageContent: React.Dispatch<React.SetStateAction<string>>;
}

function PremiumPlanModal({
  isOpen,
  onClose,
  allCargosInputStates,
  currentActiveCargoIndex,
  setIsSumInsuredBreakdownModalOpened,
  setPageContent,
}: IProps) {
  const { user }: any = useContext(UserContext);
  const [selectedPremiumPlan, setSelectedPremiumPlan] =
    useState<ISinglePolicyPlan | null>(null);

  const handleBuyPlan = function () {
    setPageContent("stage-four");
    onClose();
  };

  useEffect(() => {
    if (isOpen && !isEmpty(user)) {
      const plans = allClauseTypes?.map((clauseType) => {
        return {
          value: clauseType.value,
          key: clauseType.key,
          rate: user?.rate[clauseType.key] || 0,
        };
      });

      if (plans) {
        const currentSelectedPlan = plans.filter(
          (plan: ISinglePolicyPlan) =>
            plan.key === allCargosInputStates[currentActiveCargoIndex].clause
        );
        setSelectedPremiumPlan(currentSelectedPlan[0]);
      }
    }
  }, [isOpen, user, allCargosInputStates, currentActiveCargoIndex]);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="premium-plan-modal-overlay" onClick={onClose} />
      <div className="premium-plan-modal-container">
        <div className="premium-plan-modal-container--inner">
          <div className="cancel-modal-button-wrapper">
            <button type="button" onClick={onClose}>
              <img src={cancelIcon} alt="" />
            </button>
          </div>

          <div className="policy-form-three-header-box-wrapper">
            <div className="form-header-box--sub-text">Sum insured</div>
            <div className="form-header-box--main-text">
              <span className="currency">
                {user?.currency === "USD" ? "$" : "₦"}
              </span>
              {user?.currency === "USD"
                ? (
                    Math.round(
                      (Number(
                        allCargosInputStates[currentActiveCargoIndex].sumInsured
                      ) /
                        user?.exchangeRate) *
                        10
                    ) / 10
                  )?.toLocaleString()
                : Number(
                    allCargosInputStates[currentActiveCargoIndex].sumInsured
                  )?.toLocaleString()}
            </div>

            <div className="sum-insured-info-button-wrapper">
              <button
                type="button"
                title="Breakdown of sum insured"
                onClick={() => setIsSumInsuredBreakdownModalOpened(true)}
              >
                <InfoCircleOutlined color="red" />
              </button>
            </div>
          </div>

          <div className="policy-plan-selection-container">
            <div className="policy-plan-selection-title-wrapper">
              Premium plan
            </div>

            <div className="policy-plan-selection-boxes-wrapper">
              <div className="policy-plan-box-wrapper">
                <div className="policy-plan-box-wrapper--inner">
                  <div className="plan-name-wrapper">
                    {selectedPremiumPlan?.value}
                  </div>
                  <div className="plan-price-wrapper">
                    <span className="currency">
                      {user?.currency === "USD" ? "$" : "₦"}
                    </span>
                    {user?.currency === "USD"
                      ? (
                          Math.round(
                            getInsurancePremium(
                              Number(
                                allCargosInputStates[currentActiveCargoIndex]
                                  ?.sumInsured
                              ),
                              parseFloat(
                                allCargosInputStates[currentActiveCargoIndex]
                                  .rate
                              ) / user?.exchangeRate
                            ) * 10
                          ) / 10
                        )?.toLocaleString()
                      : getInsurancePremium(
                          Number(
                            allCargosInputStates[currentActiveCargoIndex]
                              ?.sumInsured
                          ),
                          parseFloat(
                            allCargosInputStates[currentActiveCargoIndex].rate
                          )
                        )?.toLocaleString()}
                  </div>

                  <div className="buy-plan-button-wrapper">
                    <button type="button" onClick={handleBuyPlan}>
                      Buy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PremiumPlanModal;
